import React from 'react';
import PropTypes from 'prop-types';
import { useWizard } from 'ui-components/components/wizard/context';

import ProgressButton from './progress-button';
import SubmitButton from './submit-button';

const PrimaryActionButton = ({ disabled = false, handleContinueEnablingSmartRouting }) => {
  const { nextStep } = useWizard();

  if (nextStep) {
    return <ProgressButton disabled={disabled} />;
  }

  return <SubmitButton disabled={disabled} handleContinueEnablingSmartRouting={handleContinueEnablingSmartRouting} />;
};

PrimaryActionButton.propTypes = {
  disabled: PropTypes.bool,
  handleContinueEnablingSmartRouting: PropTypes.func.isRequired,
};

export default PrimaryActionButton;
